
<template>
  <div :class="isMobile ? 'main-m' : 'main'" >
    <div class="img-box" @click="openVideo()">
      <img :src="bgUrl" class="img-style" />
      <i class="el-icon-video-play img-play-icon"></i>
    </div>
    <el-dialog
        title=""
        :show-close="false"
        :visible.sync="isVisible"
        :width="isMobile ? '96%': '50%'"
        class="dialog-style">
        <div v-if="isVisible">
          <video class="bigImg" controls width="100%" :src="videoUrl" :poster="null" autoplay>
            您的浏览器不支持HTML5视频播放，请尝试使用现代浏览器如Chrome、Firefox或Edge。
          </video>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'video',
    data() {
      return {
        isMobile: window.innerWidth < 780,
        isVisible: false
      }
    },
    props: {
        bgUrl: {
            type: String,
            default: require("./../assets/company.jpg")
        },
        videoUrl: {
            type: String,
            default: "https://mqtt.aisensing.cn/video/电子鼻嗅探机器人.mp4"
        }
    },
    mounted() {
        window.addEventListener("resize", this.initFunc)
        // console.log("bgUrl", this.bg)
        // console.log("videoUrl", this.videoUrl)
    },
    methods: {
      initFunc() {
        this.isMobile = window.innerWidth < 780
      },
      openVideo(){
        this.isVisible = true
      }
    },
    destroyed() {
        window.removeEventListener("resize", this.initFunc)
    },
  }
</script>


<style scoped lang="less">
  .dialog-style{
    /deep/ .el-dialog__body{
      padding: 0;
      line-height: 0;
    }
    /deep/ .el-dialog__header{
      padding: 0;
    }
  }
  .main{
    .img-box{
      text-align: center;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      .img-style{
        width: 100%;
        height: 194px;
        transition: all 0.3s ease;
      }
      .img-play-icon{
        color: #e8e8e8;
        font-size: 60px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .img-box:hover{
      .img-style{
        opacity: 0.9;
      }
      .img-play-icon{
        color: #e8e8e8;
      }
    }
  }
  .main-m{
    .img-box{
      text-align: center;
      position: relative;
      .img-style{
        width: 100%;
        max-height: 5.6rem;
        transition: all 0.3s ease;
      }
      .img-play-icon{
        color: #e8e8e8;
        font-size: 1.2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .img-box:hover{
      .img-style{
        opacity: 0.9;
      }
      .img-play-icon{
        color: #e8e8e8;
      }
    }
  }
</style>